import React, { lazy, Suspense } from "react";
import { Dashboard as DashboardIcon } from "@mui/icons-material";

const LazyLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      minHeight: 200,
      paddingTop: 40,
    }}
  >
    <span style={{ color: "inherit", fontSize: "0.85rem", opacity: 0.5 }}>
      Cargando...
    </span>
  </div>
);

const makeLazy = (importFn) => lazy(importFn);

const _Empresa = makeLazy(() =>
  import("./views/ArchivosCards/_Empresa/_Empresa"),
);
const ActaEntregaRecepcion = makeLazy(() =>
  import("./views/Personas/ActaEntregaRecepcion/ActaEntregaRecepcion"),
);
const Actividades = makeLazy(() =>
  import("./views/Configuración/Actividades/Actividades"),
);
const ActividadesAsignadas = makeLazy(() =>
  import("./views/Configuración/ActividadesAsignadas/ActividadesAsignadas"),
);
const ActividadesCabecera = makeLazy(() =>
  import("./views/ActividadesCabecera/ActividadesCabecera"),
);
const ActividadesOperativas = makeLazy(() =>
  import("./views/ArchivosCards/ActividadesOperativas/ActividadesOperativas"),
);
const ActividadesOperativasModulo = makeLazy(() =>
  import(
    "./views/ActividadesOperativas/ActividadesOperativas"
  ),
);
const Anticipos = makeLazy(() => import("./views/Anticipos/Anticipos"));
const Vacaciones = makeLazy(() => import("./views/Vacaciones/Vacaciones"));
const Config_Horarios = makeLazy(() =>
  import("./views/Configuración/Config_Horarios/Config_Horarios.js"),
);
const Aportes = makeLazy(() => import("./views/Configuración/Aportes/Aportes"));
const Asistencias = makeLazy(() => import("./views/Asistencias/Asistencias"));
const Ausencia = makeLazy(() => import("./views/Ausencia/Ausencia"));
const Condominios = makeLazy(() => import("./views/Condominios/Condominios"));
const Propiedades = makeLazy(() => import("./views/Propiedades/Propiedades"));
const Carrusel = makeLazy(() => import("./views/Carrusel/Carrusel.js"));
const Vehiculos = makeLazy(() => import("./views/Vehiculos/Vehiculos"));
const Individuos = makeLazy(() => import("./views/Individuos/Individuos"));
const Vinculos = makeLazy(() => import("./views/Vinculos/Vinculos"));
const Avisos = makeLazy(() => import("./views/Personas/Avisos/Avisos"));
const AvisoSalida = makeLazy(() => import("./views/AvisoSalida/AvisoSalida"));
const InventarioFactura = makeLazy(() =>
  import("./views/InventarioFactura/InventarioFactura"),
);
const Bancos = makeLazy(() => import("./views/Configuración/Bancos/Bancos"));
const Bitacora = makeLazy(() => import("./views/Pass/ModuloPass"));
const BitacoraSincop = makeLazy(() =>
  import("./views/Bitacora/BitacoraSincop"),
);
const ModuloPass = makeLazy(() => import("./views/Pass/ModuloPass"));
const Bitacora_ = makeLazy(() =>
  import("./views/ArchivosCards/Bitacora_/Bitacora_"),
);
const Bodega = makeLazy(() => import("./views/Configuración/Bodega/Bodega"));
const Categorias = makeLazy(() =>
  import("./views/Configuración/Categorias/Categorias.js"),
);
const Bodegas = makeLazy(() => import("./views/Configuración/Bodegas/Bodegas"));
const Stocks = makeLazy(() => import("./views/Configuración/Stocks/Stocks.js"));
const CambioPuesto = makeLazy(() =>
  import("./views/CambioPuesto/CambioPuesto"),
);
const Capacitacion = makeLazy(() =>
  import("./views/Capacitacion/Capacitacion"),
);
const Ciudades = makeLazy(() =>
  import("./views/Configuración/Ciudades/Ciudades"),
);
const AreaDepartamento = makeLazy(() =>
  import("./views/Configuración/AreaDepartamento/AreaDepartamento.js"),
);
const Comprobantes = makeLazy(() =>
  import("./views/Configuración/Comprobantes/Comprobantes"),
);
const FormasPagos = makeLazy(() =>
  import("./views/Configuración/FormasPagos/FormasPagos"),
);
const Actualizaciones = makeLazy(() =>
  import("./views/Configuración/Actualizaciones/Actualizaciones.js"),
);
const Clientes = makeLazy(() => import("./views/Personas/Clientes/Clientes"));
const Compras = makeLazy(() => import("./views/Compras/Compras.js"));
const CuentasPorCobrar = makeLazy(() =>
  import("./views/Configuración/CuentasCobrar/CuentasPorCobrar.js"),
);
const Configuraciones = makeLazy(() =>
  import("./views/ArchivosCards/Configuraciones/Configuraciones"),
);
const NovedadesNomina = makeLazy(() =>
  import("./views/ArchivosCards/NovedadesNomina/NovedadesNomina"),
);
const Consignas = makeLazy(() =>
  import("./views/Personas/Consignas/Consignas"),
);
const CumplimientoActividades = makeLazy(() =>
  import("./views/CumplimientoActividades/CumplimientoActividades"),
);
const Dashboard = makeLazy(() => import("./views/Dashboard/Dashboard"));
const DatosOperativos = makeLazy(() =>
  import("./views/DatosOperativos/DatosOperativos"),
);
const Distribucion = makeLazy(() =>
  import("./views/Distribucion/Distribucion"),
);
const Distribuciones = makeLazy(() =>
  import("./views/Distribuciones/Distribuciones"),
);
const Documentos = makeLazy(() =>
  import("./views/Configuración/Documentos/Documentos"),
);
const DocumentosExpirados = makeLazy(() =>
  import("./views/DocumentosExpirados/DocumentosExpirados"),
);
const Empresas = makeLazy(() =>
  import("./views/Configuración/Empresas/Empresas"),
);
const MovimientosStock = makeLazy(() =>
  import("./views/Configuración/MovimientosStock/MovimientosStock"),
);
const EncuestasEvaluaciones = makeLazy(() =>
  import("./views/EncuestasEvaluaciones/EncuestasEvaluaciones"),
);
const EstadoCuentas = makeLazy(() =>
  import("./views/Personas/EstadoCuentas/EstadoCuentas"),
);
const Evaluaciones = makeLazy(() =>
  import("./views/Configuración/Evaluaciones/Evaluaciones"),
);
const EventosActividades = makeLazy(() =>
  import("./views/EventosActividades/EventosActividades"),
);
const Fop = makeLazy(() => import("./views/Fop/Fop"));
const GOP = makeLazy(() => import("./views/GOP/GOP"));
const Horarios = makeLazy(() => import("./views/Horarios/Horarios.js"));
const Informes = makeLazy(() => import("./views/Informes/Informes"));
const Informes_ = makeLazy(() =>
  import("./views/ArchivosCards/Informes_/Informes_"),
);
const Inventario = makeLazy(() => import("./views/Inventario/Inventario"));
const IOP = makeLazy(() => import("./views/IOP/IOP"));
const ISO = makeLazy(() => import("./views/ISO/ISO"));
const Iso_ = makeLazy(() => import("./views/ArchivosCards/Iso_/Iso_"));
const Logistica = makeLazy(() =>
  import("./views/ArchivosCards/Logistica/Logistica"),
);
const LugarTrabajo = makeLazy(() =>
  import("./views/Configuración/LugarTrabajo/LugarTrabajo"),
);
const MejoraContinua = makeLazy(() =>
  import("./views/MejoraContinua/MejoraContinua"),
);
const Menu = makeLazy(() => import("./views/Menu/Menu"));
const Nomina = makeLazy(() => import("./views/ArchivosCards/Nomina/Nomina"));
const Liquidacion = makeLazy(() =>
  import("./views/ArchivosCards/Liquidacion/Liquidacion"),
);
const NominaNovedades = makeLazy(() =>
  import("./views/Configuración/NominaNovedades/NominaNovedades.js"),
);
const MultasAdministracion = makeLazy(() =>
  import("./views/Configuración/MultasAdministracion/MultasAdministracion.js"),
);
const Novedades = makeLazy(() =>
  import("./views/Configuración/Novedades/Novedades"),
);
const Operaciones = makeLazy(() =>
  import("./views/ArchivosCards/Operaciones/Operaciones"),
);
const Permisos = makeLazy(() => import("./views/Permisos/Permisos"));
const Personal = makeLazy(() =>
  import("./views/ArchivosCards/Personal/Personal"),
);
const Personas = makeLazy(() => import("./views/Personas/Personas/Personas"));
const HorariosyTurnos = makeLazy(() =>
  import("./views/Personas/HorariosyTurnos/HorariosyTurnos.js"),
);
const Planificacion = makeLazy(() =>
  import("./views/Planificacion/Planificacion"),
);
const ActividadesPlanificacion = makeLazy(() =>
  import("./views/ActividadesPlanificacion/ActividadesPlanificacion.js"),
);
const ActividadesAsignacion = makeLazy(() =>
  import("./views/ActividadesAsignacion/ActividadesAsignacion.js"),
);
const ActividadesEjecucion = makeLazy(() =>
  import("./views/ActividadesOperativas/ActividadesOperativas.js"),
);
// const ActividadesEjecucion = makeLazy(() =>
//   import("./views/ActividadesEjecucion/ActividadesEjecucion.js"),
// );
const Prestamos = makeLazy(() =>
  import("./views/Configuración/Prestamos/Prestamos.js"),
);
const Proveedores = makeLazy(() =>
  import("./views/Personas/Proveedores/Proveedores"),
);
const Registros = makeLazy(() => import("./views/Registros/Registros"));
const Residentes = makeLazy(() => import("./views/Residentes/Residentes"));
const Rolpagos = makeLazy(() => import("./views/Rolpagos/Rolpagos"));
const Transacciones = makeLazy(() => import("./views/Ventas/Transacciones"));
const Proforma = makeLazy(() => import("./views/Proforma/Proforma.js"));
const Tthh = makeLazy(() => import("./views/ArchivosCards/Tthh/Tthh"));
const TurnoExtra = makeLazy(() => import("./views/TurnoExtra/TurnoExtra"));
const TurnosExtras = makeLazy(() =>
  import("./views/TurnosExtras/TurnosExtras"),
);
const Tutoriales = makeLazy(() => import("./views/Tutoriales/Tutoriales"));
const Ventas = makeLazy(() => import("./views/ArchivosCards/Ventas/Ventas"));
const Productos = makeLazy(() => import("./views/Productos/Productos.js"));
const Subcategorias = makeLazy(() =>
  import("./views/Configuración/Subcategorias/Subcategorias.js"),
);
const PlanDeCuentas = makeLazy(() =>
  import("./views/Configuración/PlanDeCuentas/PlanDeCuentas.js"),
);
const ChatParticipants = makeLazy(() =>
  import("./views/Configuración/ChatParticipants/ChatParticipants"),
);
const ChatsGroup = makeLazy(() =>
  import("./views/Configuración/ChatsGroup/ChatsGroup"),
);
const TipoArmas = makeLazy(() => import("./views/TipoArmas/TipoArmas.js"));
const CalibreArmas = makeLazy(() =>
  import("./views/CalibreArmas/CalibreArmas.js"),
);
const dashboardRoutes = [
  {
    path: "/Dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/Seguridad",
    tipo: "categoria",
  },
];

export { LazyLoader };

export const componentes = {
  _Empresa,
  Categorias,
  ActaEntregaRecepcion,
  Actividades,
  ActividadesAsignadas,
  ActividadesCabecera,
  ActividadesOperativas,
  ActividadesOperativasModulo,
  Anticipos,
  Vacaciones,
  Aportes,
  Asistencias,
  Ausencia,
  Avisos,
  AvisoSalida,
  Bancos,
  Bitacora_,
  Bitacora,
  BitacoraSincop,
  ModuloPass,
  Bodega,
  Bodegas,
  CambioPuesto,
  Capacitacion,
  Ciudades,
  Clientes,
  Compras,
  Configuraciones,
  Consignas,
  CumplimientoActividades,
  Dashboard,
  DatosOperativos,
  Distribucion,
  Distribuciones,
  Documentos,
  DocumentosExpirados,
  Empresas,
  EncuestasEvaluaciones,
  EstadoCuentas,
  Evaluaciones,
  EventosActividades,
  Fop,
  GOP,
  Horarios,
  Informes_,
  Informes,
  Inventario,
  IOP,
  Iso_,
  ISO,
  Logistica,
  LugarTrabajo,
  MejoraContinua,
  Menu,
  Nomina,
  NominaNovedades,
  Novedades,
  Operaciones,
  Permisos,
  Personal,
  Personas,
  HorariosyTurnos,
  Planificacion,
  Prestamos,
  Proveedores,
  Registros,
  Residentes,
  Rolpagos,
  Transacciones,
  Tthh,
  TurnoExtra,
  TurnosExtras,
  Tutoriales,
  Ventas,
  Productos,
  Stocks,
  Liquidacion,
  Comprobantes,
  FormasPagos,
  InventarioFactura,
  Subcategorias,
  PlanDeCuentas,
  ChatParticipants,
  ChatsGroup,
  CuentasPorCobrar: CuentasPorCobrar,
  Actualizaciones,
  MovimientosStock,
  ActividadesPlanificacion,
  ActividadesAsignacion,
  ActividadesEjecucion,
  MultasAdministracion,
  AreaDepartamento,
  NovedadesNomina,
  Proforma,
  Condominios,
  Vehiculos,
  Individuos,
  Vinculos,
  Carrusel,
  Propiedades,
  TipoArmas,
  CalibreArmas,
  Config_Horarios,
};

export default dashboardRoutes;
